import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';
import { TransactionsService } from 'src/app/services/transactions.service';
import { ProofService } from 'src/app/services/proof.service';
import { EbayPayouts, Transaction } from '@contracts/interfaces/transaction.interfaces';
import { CSVService } from 'src/app/services/csv.service';
import { InvoicesService } from '../../services/invoices.service';
import { ACCOUNT } from 'src/app/accounts';
import { JobService } from 'src/app/services/job.service';
import { Job } from '@contracts/interfaces/job.interface';

export interface DialogData {
    transaction: Transaction,
}

const TRANSFER_NOTE_MAX_LENGTH = 24;

@Component({
  selector: 'app-dialog-ebay-revenue',
  templateUrl: 'ebay-revenue.dialog.html',
  styleUrls: ['./ebay-revenue.dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EbayRevenueDialogComponent {

  transaction: Transaction;

  transfers: any[] = [];

  ebayFees = 0;
  ebayOrders = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EbayRevenueDialogComponent>,
    public proofService: ProofService,
    public csvService: CSVService,
    public transactionService: TransactionsService,
    public invoiceService: InvoicesService,
    public jobService: JobService
    ) {
      this.transaction = data.transaction;
    }

  ngOnInit() {
    this.findInvoices();

    console.log(this.transaction.ebayPayouts)
  }

  findInvoices() {
    if (this.transaction.ebayPayouts != undefined) {

      for (let i=0; i<this.transaction.ebayPayouts.length;i++) {
        this.invoiceService.find({custom: this.transaction.ebayPayouts[i].order}).subscribe((invoices: InvoiceInterface[]) => {

          if (invoices.length > 0) {
            this.transaction.ebayPayouts[i].invoice = invoices[0].number;
          }
        })
      }
    }
  }


  save() {
    this.transactionService.update(this.transaction).subscribe(r => {
      this.close("sorted");
    });
  }

  submitProof(event: any) {

    this.csvService.fileToJSON(event.addedFiles[0]).subscribe(r => {

      if (r != undefined) {
        // 8: Payout total ($109.22 AUD)
        // 9: Headers
        // 10-X: Pay outs

        // Merge any with duplicate 

        let payoutsCompiled: EbayPayouts[] = [];
        let orderPayoutsCompiled: EbayPayouts[] = [];
        //console.log(r);

        for (let i = 11; i < r.length; i++) {

          if (r[i].field2 == "Hold") {
            let x = {
              type: "Hold",
              order: r[i].field3,
              customer: {
                buyerUsername: r[i].field5,
                buyerName: r[i].field6,
                deliverycity: r[i].field7,
                deliveryProvince: r[i].field8,
                deliveryPostcode: r[i].field9,
                deliveryCountry: r[i].field10,
              },
              payout: null,
              item: null,
              feesBreakdown: null,
              fees: 0,
              amount: 0,
              refund: null,
              raw: r[i]
            };

            if (strToCents(r[i].field11) > 0) {
              x.amount = strToCents(r[i].field11);
            } else {
              x.fees = strToCents(r[i].field11);
            }

            payoutsCompiled.push(x);
          }

          if (r[i].field2 == "Postage label") {
            payoutsCompiled.push({
              type: "Postage label",
              order: r[i].field3,
              customer: {
                buyerUsername: r[i].field5,
                buyerName: r[i].field6,
                deliverycity: r[i].field7,
                deliveryProvince: r[i].field8,
                deliveryPostcode: r[i].field9,
                deliveryCountry: r[i].field10,
              },
              payout: null,
              item: null,
              feesBreakdown: null,
              fees: strToCents(r[i].field11),
              amount: 0,
              refund: null,
              raw: r[i]
            });
          }

          // Refund Triggered buy us
          if (r[i].field2 == "Refund") {

            let feeTotal = 0;
    
            // "Final value fee - fixed"
            if (r[i].field28 != '--') {
              feeTotal += +r[i].field28;
            }
  
            // "Final value fee - variable"
            if (r[i].field29 != '--') {
              feeTotal += +r[i].field29;
            }
  
            // "Very high 'Item not as described' fee"
            if (r[i].field30 != '--') {
              feeTotal += +r[i].field30;
            }
  
            // "Below standard performance fee"
            if (r[i].field31 != '--') {
              feeTotal += +r[i].field31;
            }

            feeTotal = +(Math.round(+(feeTotal + "e+2"))  + "e-2");

            payoutsCompiled.push({
              type: "Refund",
              order: r[i].field3,
              customer: {
                buyerUsername: r[i].field5,
                buyerName: r[i].field6,
                deliverycity: r[i].field7,
                deliveryProvince: r[i].field8,
                deliveryPostcode: r[i].field9,
                deliveryCountry: r[i].field10,
              },
              payout: {
                payoutDate: r[i].field13,
                payoutID: r[i].field14,
                payoutmethod: r[i].field15,
                payoutStatus: r[i].field16,
                reasonForHold: r[i].field17,
                transactionID: r[i].field19,
              },
              item: { 
                itemID: r[i].field18,
                itemTitle: r[i].field20,
                itemSubtotal: r[i].field23,
                quantity: r[i].field22,
              },
              feesBreakdown: {
                finalValueFeeFixed: r[i].field28,
                finalValueFeeVariable: r[i].field29,
                veryHighItemNotAsDescribedFee: r[i].field30,
                belowStandardPerformanceFee: r[i].field31,
              },
              fees: feeTotal * 100,
              amount: 0,
              refund: strToCents(r[i].field11),
              raw: r[i]
            });
          } 
          
          if (r[i].field2 == "Charge") {

            if (r[i-1] != undefined) {
              if (r[i-1].field2 == "Refund") {

              }
            }
            //console.log(r[i])

            payoutsCompiled.push({
              type: "Charge",
              order: r[i].field3,
              customer: {
                buyerUsername: r[i].field5,
                buyerName: r[i].field6,
                deliverycity: r[i].field7,
                deliveryProvince: r[i].field8,
                deliveryPostcode: r[i].field9,
                deliveryCountry: r[i].field10,
              },
              payout: {
                payoutDate: r[i].field13,
                payoutID: r[i].field14,
                payoutmethod: r[i].field15,
                payoutStatus: r[i].field16,
                reasonForHold: r[i].field17,
                transactionID: r[i].field19,
              },
              item: { 
                itemID: r[i].field18,
                itemTitle: r[i].field20,
                itemSubtotal: r[i].field23,
                quantity: r[i].field22,
              },
              feesBreakdown: {
                finalValueFeeFixed: r[i].field28,
                finalValueFeeVariable: r[i].field29,
                veryHighItemNotAsDescribedFee: r[i].field30,
                belowStandardPerformanceFee: r[i].field31,
              },
              fees: 0,
              amount: 0,
              refund: strToCents(r[i].field11),
              raw: r[i]
            });
          } 
          
          if (r[i].field2 == "Other fee") {
            payoutsCompiled.push({
              type: "Ebay Expense",
              amount: 0,
              fees: strToCents(r[i].field11),
              customer: null,
              feesBreakdown: null,
              item: null,
              order: null,
              payout: null,
              raw: r[i]
            });
          }
       
          if (r[i].field2 == "Order") {
            // Skip any that have blank "Amout fields"
            // This happens when an order has mutliple items
            // and the CSV has an item for each iteration of the loop.
            // We merge these further down the bottom of code..
            if (r[i].field23 != "--") {
              let feeTotal = 0;

              // "Final value fee - fixed"
              if (r[i].field28 != '--') {
                feeTotal += +r[i].field28;
              }
    
              // "Final value fee - variable"
              if (r[i].field29 != '--') {
                feeTotal += +r[i].field29;
              }
    
              // "Very high 'Item not as described' fee"
              if (r[i].field30 != '--') {
                feeTotal += +r[i].field30;
              }
    
              // "Below standard performance fee"
              if (r[i].field31 != '--') {
                feeTotal += +r[i].field31;
              }

              // International Sales Fee
              if (r[i].field32 != '--') {
                feeTotal += +r[i].field32;
              }

              feeTotal = +(Math.round(+(feeTotal + "e+2"))  + "e-2");

              orderPayoutsCompiled.push({
                type: "Order",
                order: r[i].field3,
                customer: {
                  buyerUsername: r[i].field5,
                  buyerName: r[i].field6,
                  deliverycity: r[i].field7,
                  deliveryProvince: r[i].field8,
                  deliveryPostcode: r[i].field9,
                  deliveryCountry: r[i].field10,
                },
                payout: {
                  payoutDate: r[i].field13,
                  payoutID: r[i].field14,
                  payoutmethod: r[i].field15,
                  payoutStatus: r[i].field16,
                  reasonForHold: r[i].field17,
                  transactionID: r[i].field19,
                },
                item: { 
                  itemID: r[i].field18,
                  itemTitle: r[i].field20,
                  itemSubtotal: r[i].field23,
                  quantity: r[i].field22,
                },
                feesBreakdown: {
                  finalValueFeeFixed: r[i].field28,
                  finalValueFeeVariable: r[i].field29,
                  veryHighItemNotAsDescribedFee: r[i].field30,
                  belowStandardPerformanceFee: r[i].field31,
                },
                fees: feeTotal * 100,
                amount: +r[i].field22 * strToCents(r[i].field23) + strToCents(r[i].field24),
                raw: r[i]
              });
            }
          }

          // Refund triggered by Buyer
          if (r[i].field2 == "Claim") {
            let feeTotal = 0;
    
            // "Final value fee - fixed"
            if (r[i].field28 != '--') {
              feeTotal += +r[i].field28;
            }
  
            // "Final value fee - variable"
            if (r[i].field29 != '--') {
              feeTotal += +r[i].field29;
            }
  
            // "Very high 'Item not as described' fee"
            if (r[i].field30 != '--') {
              feeTotal += +r[i].field30;
            }
  
            // "Below standard performance fee"
            if (r[i].field31 != '--') {
              feeTotal += +r[i].field31;
            }

            feeTotal = +(Math.round(+(feeTotal + "e+2"))  + "e-2");

            payoutsCompiled.push({
              type: "Claim",
              order: r[i].field3,
              customer: {
                buyerUsername: r[i].field5,
                buyerName: r[i].field6,
                deliverycity: r[i].field7,
                deliveryProvince: r[i].field8,
                deliveryPostcode: r[i].field9,
                deliveryCountry: r[i].field10,
              },
              payout: {
                payoutDate: r[i].field13,
                payoutID: r[i].field14,
                payoutmethod: r[i].field15,
                payoutStatus: r[i].field16,
                reasonForHold: r[i].field17,
                transactionID: r[i].field19,
              },
              item: { 
                itemID: r[i].field18,
                itemTitle: r[i].field20,
                itemSubtotal: r[i].field23,
                quantity: r[i].field22,
              },
              feesBreakdown: {
                finalValueFeeFixed: r[i].field28,
                finalValueFeeVariable: r[i].field29,
                veryHighItemNotAsDescribedFee: r[i].field30,
                belowStandardPerformanceFee: r[i].field31,
              },
              fees: feeTotal * 100,
              amount: 0,
              refund: strToCents(r[i].field11),
              raw: r[i]
            });
          }
        }
        
        let orders: EbayPayouts[] = [];
        for (let payout of orderPayoutsCompiled) {
          // Merge orders
          if (payout.type == "Order") {

            let found = false;
            for (let i=0; i<orders.length;i++) {
              if (payout.order == orders[i].order) {
                orders[i].amount += payout.amount;
                orders[i].fees += payout.fees;

                orders[i].feesBreakdown.belowStandardPerformanceFee = payout.feesBreakdown.belowStandardPerformanceFee;
                orders[i].feesBreakdown.finalValueFeeFixed = payout.feesBreakdown.finalValueFeeFixed;
                orders[i].feesBreakdown.finalValueFeeVariable = payout.feesBreakdown.finalValueFeeVariable;
                orders[i].feesBreakdown.veryHighItemNotAsDescribedFee = payout.feesBreakdown.veryHighItemNotAsDescribedFee;

                found = true;
              }
            }

            if (!found) {
              orders.push(payout);
            }
          }
        }

        payoutsCompiled.push(...orders);

        this.transaction.ebayPayouts = payoutsCompiled;

        this.findInvoices();
      }
    })
  }

  close (action: string) {
    this.dialogRef.close(action);
  }

  updateTransferDescription(transfer: { transactionDescription: string }, description: string) {
    transfer.transactionDescription = this.truncateTransferNote(description);
  }

  truncateTransferNote(note: string) {
    return (note || "").slice(0, TRANSFER_NOTE_MAX_LENGTH);
  }

  markSorted() {
    this.transaction.sorted = true;

    this.transactionService.update(this.transaction).subscribe(r=> {
      this.close("updated");
    })
  }


  fuck() {
    this.transaction.sorted = false;

    this.transactionService.update(this.transaction).subscribe(r=> {
      this.close("updated");
    })
  }


  makeTransfers () {
    let ebayFees = 0;
    this.transfers = [];

    console.log(this.transaction.ebayPayouts);

    // Handle expenses associated with Ebay
    for (let payout of this.transaction.ebayPayouts) {

      if (payout.type == "Refund") {
        // Add the fees
        ebayFees += payout.fees;

        this.transfers.push({
          srcAccount: ACCOUNT.G72EXPENSES,  // Ebay Revenue
          destAccount: ACCOUNT.G72REVENUE, // Revenue
          amount: (Math.abs((payout.refund - payout.fees)) / 100).toFixed(2),
          transactionDescription: this.truncateTransferNote("refund inv " + payout.invoice)
        });
      } else if (payout.type == "Claim") {
        this.transfers.push({
          srcAccount: ACCOUNT.G72EXPENSES,  // Ebay Revenue
          destAccount: ACCOUNT.G72REVENUE, // Revenue
          amount: (payout.amount / 100).toFixed(2),
          transactionDescription: this.truncateTransferNote("refund inv " + payout.invoice)
        });
      } else if (payout.type == "Charge") {
        this.transfers.push({
          srcAccount: ACCOUNT.G72EXPENSES,  // Ebay Revenue
          destAccount: ACCOUNT.G72REVENUE, // Revenue
          amount: (payout.refund / 100).toFixed(2),
          transactionDescription: "Ebay Charge"
        });
      } else if (payout.type == "Hold") {

      } else {
        // Telly up all the order fees
        ebayFees += payout.fees;
      }
    }

    this.transfers.push({
          srcAccount: ACCOUNT.G72EXPENSES,  // Expenses
      destAccount: ACCOUNT.G72REVENUE, // Ebay Revenue
      amount: Math.abs(ebayFees / 100).toFixed(2),
      transactionDescription: this.truncateTransferNote("Ebay Fees")
    });

    for (let payout of this.transaction.ebayPayouts) {
      if (payout.type == "Order") {
        this.transfers.push({
          srcAccount: ACCOUNT.G72REVENUE,  // Ebay Revenue
          destAccount: ACCOUNT.REVENUE, // Revenue
          amount: (payout.amount / 100).toFixed(2),
          transactionDescription: this.truncateTransferNote("inv " + payout.invoice)
        });
      }
    }
  }

  allowCommit = false;
  check () {
    this.makeTransfers();

    let balance = this.transaction.amount / 100;

    for (let transfer of this.transfers) {
      let x: number = +transfer.amount;

      if (transfer.srcAccount == ACCOUNT.G72EXPENSES) {
        balance += x;
      } else if (transfer.destAccount == ACCOUNT.REVENUE) {
        balance -= x;
      }

      balance = +(balance.toFixed(2));
    }

    if (balance == 0) {
      this.allowCommit = true;
    }

    this.allowCommit = true;
  }

  commit () {

    this.jobService.create({
      job: Job.BANK_TRANSFER,
      date: {
        start: new Date()
      },
      data: {
        transfers: this.transfers
      }
    }).subscribe(r=> {
      // Also mark all cash revenue as sorted

      this.markSorted();
    });
  }
}

function strToCents(amount: string) {
  return parseFloat(amount.replace("$", "").replace(",", "")) * 100
}

// field1: "Transaction creation date"
// field2: "Type"
// field3: "Order number"
// field4: "Legacy order ID"

// field5: "Buyer username"
// field6: "Buyer name"
// field7: "Delivery city"
// field8: "Delivery province/region/state"
// field9: "Delivery postcode"
// field10: "Delivery country"

// field11: "Net amount"
// field12: "Payout currency"

// field13: "Payout date"
// field14 : "Payout ID"
// field15 : "Payout method"
// field16 : "Payout status"
// field17 : "Reason for hold"
// field18 : "Item ID"
// field19 : "Transaction ID"
// field20 : "Item title"
// field21 : "Custom label"
// field22 : "Quantity"
// field23 : "Item subtotal"
// field24 : "Postage and handling"
// field25 : "Seller collected tax"
// field26 : "eBay collected tax"
// field27 : "Seller-specified GST rate"
// field28 : "Final value fee - fixed"
// field29 : "Final value fee - variable"
// field30 : "Very high 'Item not as described' fee"
// field31 : "Below standard performance fee"
// field32 : "International sales fee"
// field33 : "Gross transaction amount"
// field34 : "Transaction currency"
// field35 : "Exchange rate"
// field36 : "Reference ID"
// field37 : "Description"
